export const contentKeys = {
  root: ['content'] as const,
  groups: (entityId: string) => ['content', 'groups', entityId] as const,
  documents: (entityId: string) => ['content', 'documents', entityId] as const,
  document: (entityId: string, documentId: string) => ['content', 'document', entityId, documentId] as const,
  readerTree: (entityId: string) => ['content', 'reader-tree', entityId] as const,
  readerDocument: (entityId: string, slug: string) => ['content', 'reader-document', entityId, slug] as const,
  readerSearch: (entityId: string, query: string) => ['content', 'reader-search', entityId, query] as const,
  media: (entityId: string) => ['content', 'media', entityId] as const,
  versions: (entityId: string, documentId: string) => ['content', 'versions', entityId, documentId] as const,
  version: (entityId: string, documentId: string, versionId: string) => ['content', 'version', entityId, documentId, versionId] as const,
}
